module.exports = __webpack_public_path__ + "static/img/active2.6dcf3f39.png";